module.exports = __webpack_public_path__ + "img/reverse.13da02f4.png";